(ns bec-cljs-common.components.accordion
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [bec-cljs-common.utils.css :as css]))

(defonce variables (r/atom {}))

(rf/reg-event-fx
  :open-accordion
  (fn [{:keys [db]} [_ accordion-key props]]
    (let [is-active? (if (and (:is-opened? props) 
                           (nil? (if (vector? accordion-key) 
                                   (get-in @variables [(first accordion-key) (second accordion-key)] nil)
                                   (get @variables accordion-key))))
                       false
                       true)]
      (css/animating accordion-key true)
      (if (vector? accordion-key)
        (swap! variables assoc (first accordion-key) {(second accordion-key) (merge props {:is-active? is-active?})})
        (swap! variables assoc accordion-key (merge props {:is-active? is-active?}))))
    {:db db}))

(rf/reg-event-fx
  :close-accordion
  (fn [_ [_ accordion-key {:keys [on-close-event]}]]
    (css/animating accordion-key true)
    (if (vector? accordion-key)
      (swap! variables assoc (first accordion-key) {(second accordion-key) {:is-active? false}})
      (swap! variables assoc accordion-key {:is-active? false}))
    {:fx [(when on-close-event [:dispatch on-close-event])]}))

(defn header [props]
  (let [accordion-key (:accordion-key props)
        accordion-group-key (:accordion-group-key props)
        accordion-vars (if accordion-group-key
                         (get-in @variables [accordion-group-key accordion-key] nil)
                         (get @variables accordion-key))
        opened? (:is-opened? props)
        active? (:is-active? accordion-vars)
        on-function (fn []
                      (when-not (fn? (:on-click props))
                        (if (and opened? (nil? active?))
                          (when (fn? (:on-close props))
                            ((:on-close props)))
                          (if active?
                            (when (fn? (:on-close props))
                              ((:on-close props)))
                            (when (fn? (:on-open props))
                              ((:on-open props))))))
                      (when (fn? (:on-click props))
                        ((:on-click props))))
        on-click (if accordion-key
                   #(do
                      (rf/dispatch
                        (if active?
                          [:close-accordion (if accordion-group-key
                                              [accordion-group-key accordion-key]
                                              accordion-key)]
                          [:open-accordion (if accordion-group-key
                                             [accordion-group-key accordion-key]
                                             accordion-key) {:is-opened? (:is-opened? props)}]))
                      (on-function))
                   on-function)]
    (->
      (into
        [:button.panel-heading.is-clickable
         (merge
           {:on-click on-click}
           (when (map? props)
             (dissoc props :accordion-key :accordion-group-key :is-opened? :on-open :on-close))
           {:style (merge
                     (:style props)
                     {:transform "none"
                      :width "100%"})})]
        (r/children (r/current-component)))
      (into
        [[:span.icon
          {:style {:transform (if (or (and opened? (nil? active?)) active?)
                                "rotate(180deg)"
                                "rotate(0deg)")
                   :transition "transform var(--transition-duration, 250ms) ease"}}
          [:i.fas.fa-caret-down]]]))))

(defn body [props]
  (let [opened? (:is-opened? props)
        active? (:is-active? props)
        is-animating? @(rf/subscribe [:is-animating? (:accordion-key props)])]
    (into
      [:div.is-collapsible
       (merge
         (when (map? props)
           (dissoc props :is-opened? :is-active? :accordion-key :accordion-group-key))
         {:class (str (:class props) 
                   (when-not (or (and opened? (nil? active?)) active?) " is-collapsed ")
                   (when is-animating? " is-animating "))
          :on-transition-end #(css/animating (:accordion-key props) false)})]
      (r/children (r/current-component)))))

(defn block [props]
  (let [accordion-key (:accordion-key props)
        accordion-group-key (:accordion-group-key props)
        accordion-vars (if accordion-group-key 
                         (get-in @variables [accordion-group-key accordion-key])
                         (get @variables accordion-key))
        active? (:is-active? accordion-vars)]
    [:nav.panel.is-accordion
     (when (map? props)
       (dissoc props :accordion-key :accordion-group-key :header-child :header-props :body-props :is-opened?))
     [header
      (merge
        (:header-props props)
        {:accordion-key accordion-key
         :accordion-group-key accordion-group-key
         :is-opened? (:is-opened? props)
         :class (or (:class (:header-props props)) (:class props))})
      (:header-child props)]
     (into
       [body
        (merge
          {:accordion-key accordion-key
           :accordion-group-key accordion-group-key
           :is-opened? (:is-opened? props)
           :is-active? active?}
          (:body-props props))]
       (r/children (r/current-component)))]))

(defn container [props]
  (into
    [:section.section
     (merge
       (when (map? props)
         props)
       {:style (merge
                 {:padding-left 0
                  :padding-right 0}
                 (:style props))})]
    (r/children (r/current-component))))